import * as styles from './styles';
import FocusableButton from '@components/FocusableButton';
import { CONFIRM_BUTTON } from '@pages/EndInstruction/focuskey';
import { useEndInstructionContext } from '@context/EndInstruction';

const Instruction = () => {
  const { goMain } = useEndInstructionContext();

  return (
    <div css={styles.container}>
      <div css={styles.textContainer}>
        <p css={styles.title}>진료가 종료되었어요</p>
        <p css={styles.instruction}>1. 진료비를 결제해주세요.</p>
        <p css={styles.instruction}>
          2. 처방전을 확인하고 처방약 수령 방법을 선택해주세요.
        </p>
      </div>
      <div css={styles.bottomContainer}>
        <FocusableButton focusKey={CONFIRM_BUTTON} onEnterPress={goMain}>
          확인
        </FocusableButton>
      </div>
    </div>
  );
};

export default Instruction;
